import { IconButton } from "@material-ui/core";
import React, { memo } from "react";
import { ReactComponent as EditIcon } from "../../../Assets/Images/edit.svg";
import { ReactComponent as ViewIcon } from "../../../Assets/Images/view.svg";
import textStyle from "../../../style/typography";
import PrimaryButton from "../Buttons/PrimaryButton";
import { StyledCard, StyledCardContent } from "../Card";
import tableStyles from "../../../style/table";

const CustomCard = ({
  children,
  title,
  mt,
  key,
  hasActionBtn,
  actionBtnTitle,
  onAction,
  editing,
  canEdit,
  onEdit,
  hasSecondaryBtn,
  secondaryBtnTitle,
  onSecondaryAction,
  formMode,
  setFormMode,
  hasFormMode,
  customStyle,
  hasIcon,
  icon,
  customContentStyle,
  hideActionIcon,
  customElevation,
}) => {
  const textClasses = textStyle();
  const tableClasses = tableStyles();

  return (
    <StyledCard
      elevation={customElevation ?? 1}
      style={{
        marginTop: mt ? "12px" : "0px",
        padding: 0,
        ...customStyle,
        borderRadius: "1rem",
      }}
      key={key}
    >
      <div
        className={`${tableClasses.tableHeader}`}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p className={`${textClasses.header2}  ${textClasses.semibold}`}>
          {title ?? `~`}
        </p>
        <div>
          {hasIcon && <>{icon}</>}
          {hasSecondaryBtn && (
            <PrimaryButton
              hideIcon={true}
              onClick={onSecondaryAction}
              style={{ marginRight: hasActionBtn ? 6 : 0 }}
            >
              {secondaryBtnTitle}
            </PrimaryButton>
          )}
          {editing ? (
            <IconButton size="small" onClick={onEdit} style={{ padding: 0 }}>
              <EditIcon />
            </IconButton>
          ) : (
            <>
              {hasActionBtn && (
                <PrimaryButton
                  onClick={onAction}
                  hideIcon={hideActionIcon === true}
                >
                  {actionBtnTitle}
                </PrimaryButton>
              )}
            </>
          )}
          {hasFormMode && (
            <>
              {!formMode ? (
                <IconButton
                  onClick={() => setFormMode(!formMode)}
                  style={{ padding: 0 }}
                >
                  <EditIcon />
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => setFormMode(!formMode)}
                  style={{ padding: 0 }}
                >
                  <ViewIcon />
                </IconButton>
              )}
            </>
          )}
        </div>
      </div>

      <StyledCardContent
        className={`${tableClasses.tableBody}`}
        style={customContentStyle ? customContentStyle : {}}
      >
        {children}
      </StyledCardContent>
    </StyledCard>
  );
};

export default memo(CustomCard);
